import _ from "lodash";
import { useState, useEffect } from "react";
import Peg from "./Peg";
import Indicator from "./Indicator";

const Row = ({currentColors, randomColors, id, currentID, resetPegs, setCheckWinner, handleClick}) => {
  const [indColors, setIndColors] = useState({green: 0, yellow: 0});
  const [colors, setColors] = useState(['', '','','']);
  const [checked, setChecked] = useState(false);
  const [checkDisabled, setCheckDisabled] = useState(true);

  useEffect(() => {
    if (id === currentID && checked === false) {
      setColors(currentColors);
    }
  },[currentID, currentColors, id, checked]);

  useEffect(() => {
    let filledColors = colors.map((el) => el.length).filter((i) => i).length;
    if (filledColors === 4 && !checked && id === currentID) {
      setCheckDisabled(false);
    } else {
      setCheckDisabled(true);
    }
  },[checkDisabled, id, currentID, colors, checked]);

  useEffect(() => {
    if (resetPegs) {
      setIndColors({green: 0, yellow: 0});
      setColors(['', '','','']);
      setChecked(false);
      setCheckDisabled(true);
    }
  },[resetPegs]);

  const handleCheck = () => {
    if (!checkDisabled) {
      let ind = {yellow: 0, green: 0};
      // Get number of correctly possitioned pegs
      ind.green = colors.map((col, i) => col === randomColors[i]).filter((res) => res === true).length;

      // Copy only not correctly positioned pegs to new arrays 
      let randomColorsArr = [];
      let colorArr = [];
      for (let i=0; i < colors.length; i++) {
        if (colors[i] !== randomColors[i]) {
          randomColorsArr.push(randomColors[i]);
          colorArr.push(colors[i]);
        }
      };

      // Run through rest of colors, check if it is in other array and take it out, if it is
      // Number of remained elements in randomColorsArr are grey color - not correct collors
      for (let i=0; i < colorArr.length; i++) {
        let index = randomColorsArr.indexOf(colorArr[i]);
        if (index >= 0) {
          randomColorsArr.splice(index, 1);
        }
      }

      ind.yellow = 4 - ind.green - randomColorsArr.length;
      setIndColors(ind);
      setChecked(true);
      setCheckWinner(true);
      setCheckDisabled(true);
    }
  }

  return (
    <div className="row">
      {(colors.map((col,j) => <Peg pegColor={col} id={`${id}-${j}`} key={`${id}-${j}`} handleClick={handleClick} />))}
      <div className={`check ${(checkDisabled) ? 'grey' : ''}`} id={`${id}-check`} onClick={() => handleCheck()} 
          disabled={checkDisabled}>
        check
      </div>
      <Indicator indColors={indColors} />
    </div>
  );
}

export default Row;